import { CSSProperties } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';

// import { variables } from '@styles';

/**
 * TemplateView component styles
 * @returns {Function}
 */

const getFixedHeightAttrs = (height: string): CSSProperties => ({
  height,
  minHeight: height,
  maxHeight: height,
});

const getFixedWidthAttrs = (width: string): CSSProperties => ({
  width,
  minWidth: width,
  maxWidth: width,
});

export const useStyles = makeStyles(() =>
  createStyles({
    templateView: {
      // ...getFixedHeightAttrs(`calc(100% + 2 * ${theme.spacing(3)}px)`),
      // ...getFixedWidthAttrs(`calc(100% + 2 * ${theme.spacing(8)}px)`),
      // ...getFixedHeightAttrs(`100%`),
      // ...getFixedWidthAttrs(`100%`),
      display: 'flex',
      height: '100%',
      justifyContent: 'space-between',
      margin: '0 0', // theme.spacing(-3, -8),
      maxHeight: '100%',
      maxWidth: '100%',
      minHeight: '100%',
      minWidth: '100%',
      position: 'relative',
      width: '100%',

      ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        minWidth: '120rem',
      },
    },

    leftPanel: {
      '&&': {
        flex: '0 0 44.8rem',
        height: '100%',
        marginRight: '1.4rem',
        maxWidth: 'unset',
        minWidth: 'unset',
        width: '44.8rem',

        ['@media (min-width: 1024px) and (max-width: 1650px)']: {
          // flex: '0 0 25rem',
          flex: '0 0 calc((100% - 67.8rem)/2)', // '0 0 calc((100% - 66rem)/2)',
          marginRight: 0,
          maxWidth: '44rem',
          minWidth: '27rem',
          // width: '27rem',
          width: 'calc((100% - 67.8rem)/2)', // 'calc((100% - 66rem)/2)',
        },
      },
      '& > *': {
        ...getFixedHeightAttrs('100%'),
      },
    },

    centralPanel: {
      '&&': {
        height: '100%', // 'calc(100% - 3.6rem)', //'calc(100% - 2.4rem)',
        marginRight: '1.4rem',
        maxWidth: 'unset',
        minWidth: '64.8rem', // 'unset',
        position: 'relative',
        width: 'calc(100% - 67.2rem)',

        ['@media (min-width: 1024px) and (max-width: 1650px)']: {
          // width: 'calc(100% - 49.2rem)',
          marginLeft: '1.4rem',
          width: '66rem',
        },
      },
      // '& > *': {
      //   // ...getFixedHeightAttrs('100%'),
      //   height: 'calc(100% - 6.4rem)', //2.4rem)',
      // },
    },

    deploymentsInfo: {
      alignItems: 'center',
      background: '#fff',
      flex: '1 1',
      display: 'flex',
      height: 'calc(100% - 6.5rem)',
      justifyContent: 'center',
      margin: '0 auto',
      maxWidth: '60rem',
      textAlign: 'center',
    },

    rightPanel: {
      '&&': {
        borderLeft: 'unset',
        flex: '0 0 44.8rem',
        height: '100%',
        // marginLeft: '1.4rem',
        maxWidth: 'unset',
        minWidth: 'unset',
        width: '44.8rem',

        ['@media (min-width: 1024px) and (max-width: 1650px)']: {
          // flex: '0 0 27rem',
          flex: '0 0 calc((100% - 67.8rem)/2)', // '0 0 calc((100% - 66rem)/2)',
          maxWidth: '44rem',
          minWidth: '27rem',
          // width: '27rem',
          width: 'calc((100% - 67.8rem)/2)', // 'calc((100% - 66rem)/2)',
        },
      },
      '& > *': {
        ...getFixedHeightAttrs('100%'),
      },
    },

    overlayBackground: {
      background: 'transparent',
      height: '100%',
      position: 'absolute',
      width: '100%',
      zIndex: 20000,
      ['@media (min-width: 1024px) and (max-width: 1580px)']: {},
      ['@media (max-width: 1023px)']: {
        display: 'none',
      },
    },
    overlayContainer: {
      background: 'rgba(0, 0, 0, 0.2)',
      borderRadius: '2rem',
      height: '100%',
      position: 'relative',
      // width: 'calc(100% - 46.2rem)!important', // 'calc(100% - 44.8rem)!important',
      width: 'calc(100% - 46.3rem)',

      ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        width: 'calc( 100% - ((100% - 63.2rem - 2.8rem) / 2) - 1.4rem)',
        // width: 'calc(100% - 28.3rem)', //'calc(100% - 26.8rem)!important',
        // width: 'calc(100% - 28.2rem)!important', //'calc(100% - 26.8rem)!important',
      },
    },
    moduleHeaderPlaceholder: {
      '&&': {
        flexShrink: 0,
        height: '8.8rem', //'4.8rem',
        maxHeight: '8.8rem', //'4.8rem',
        minHeight: '8.8rem', //'4.8rem',
        // position: 'sticky',
        top: 0,
      },
    },
  }),
);
